import React from "react"

import Layout from '../components/layout'
import Link from '../components/link'

const JoinPage = (props) => (
  <Layout title="Get involved in the future of personalized medicine." subtitle="Take a part, big or small, in helping push personalized medicine into the future.">
    <p>Contact us at <a href="mailto:info@goinvo.com">info@goinvo.com</a></p>
    <h2>Flirt</h2>
    <p>We need a diverse group of patients, care teams, clinicians, data scientists, public health professionals, and researchers to view and provide critical feedback for the Health Picture.</p>
    <ul>
      <li>View and use the designs.</li>
      <li>Provide feedback on the designs.</li>
      <li>Feedback will be used to change and improve designs.</li>
    </ul>
    <h2>Date</h2>
    <p>We are building a panel of healthcare key constituents to vet and become apostles for the Health Picture. The group will meet at regular intervals to strategize, plan, and design the direction of the Health Picture.</p>
    <h2>Commit</h2>
    <p>Evolve the designs with us. Iterate on the current designs or explore new concepts.</p>
    <p>Start committing to the <a href="https://github.com/goinvo/HealthPicture" target="_blank" rel="noopener noreferrer">repository</a> today.</p>
    <h2>Join the Health Picture Movement</h2>
    <p>Align your business objectives and design needs with the Health Picture.</p>
    <p>Fund a component and the adoption of Health Picture for next generation healthcare.</p>
  </Layout>
)

export default JoinPage
